export default function (Vue, options) {

    Vue.directive('dialog-drag', {
        inserted(el) {
            const headerEl = el.querySelector('.el-dialog__header');
            const dialogEl = el.querySelector('.el-dialog');
            if (!headerEl || !dialogEl) return;

            headerEl.style.cursor = 'move';
            headerEl.style.userSelect = 'none';

            let tx = 0, ty = 0;

            headerEl.addEventListener('mousedown', (e) => {
                if (e.target.closest('.el-dialog__headerbtn')) return;

                const startX = e.clientX;
                const startY = e.clientY;
                const startTx = tx;
                const startTy = ty;

                const onMouseMove = (e) => {
                    tx = startTx + (e.clientX - startX);
                    ty = startTy + (e.clientY - startY);
                    dialogEl.style.transform = `translate(${tx}px, ${ty}px)`;
                };

                const onMouseUp = () => {
                    document.removeEventListener('mousemove', onMouseMove);
                    document.removeEventListener('mouseup', onMouseUp);
                };

                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
                e.preventDefault();
            });
        }
    });

    function rendeElScrollInfo(el, heightRemove) {
        // el.style.overflowY= "auto"
        el.style.height = (document.body.offsetHeight - heightRemove) + 'px'
    }

    Vue.filter('replaceHttps', function (value) {
        return value ? value.replace('https', 'http') : ""
    })

    Vue.directive('scroll-area', {
        bind: function (el, binding, vnode) {
            // document.body.style.overflow = "hidden"
        },
        componentUpdated: function (el, binding, vnode) {
            // console.log(binding.value)
            let heightRemove = 8
            if (binding.value instanceof Array) {
                heightRemove = binding.value.reduce((p, v) => {
                    return p + document.querySelector(v).offsetHeight + 16
                }, 0);
                // console.log(heightRemove)
            }

            rendeElScrollInfo(el, heightRemove)

            let timer = false
            window.addEventListener('resize', () => {
                if (!timer) {
                    timer = true
                    setTimeout(() => {
                        // console.log(1)
                        rendeElScrollInfo(el, heightRemove)
                        timer = false
                    }, 500)
                }
            }, false);
        }
    })

}


// WEBPACK FOOTER //
// ./src/directives/index.js